import { Card } from "flowbite-react";
import React from "react";

export default function EventContent() {
  return (
    <div className="container mt-20 mb-20 flex justify-center items-center">
      <div className="w-3/4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="col-span-1 mx-auto">
            <div className="max-w-sm">
              <Card imgSrc={require("../../images/event-1.jpg")}>
                <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                  Lorem ipsum dolor sit amet.
                </h5>
                <p className="font-normal text-gray-700 dark:text-gray-400">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam dolor dignissimos molestiae rerum nesciunt suscipit quaerat iusto consequuntur porro repellendus.
                </p>
              </Card>
            </div>
          </div>

          <div className="col-span-1 mx-auto">
            <div className="max-w-sm">
              <Card imgSrc={require("../../images/event-2.jpg")}>
                <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                  Lorem ipsum dolor sit amet.
                </h5>
                <p className="font-normal text-gray-700 dark:text-gray-400">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam dolor dignissimos molestiae rerum nesciunt suscipit quaerat iusto consequuntur porro repellendus.
                </p>
              </Card>
            </div>
          </div>

          <div className="col-span-1 mx-auto">
            <div className="max-w-sm">
              <Card imgSrc={require("../../images/event-3.jpg")}>
                <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                  Lorem ipsum dolor sit amet.
                </h5>
                <p className="font-normal text-gray-700 dark:text-gray-400">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam dolor dignissimos molestiae rerum nesciunt suscipit quaerat iusto consequuntur porro repellendus.
                </p>
              </Card>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-5">
          <div className="col-span-1 mx-auto">
            <div className="max-w-sm">
              <Card imgSrc={require("../../images/event-3.jpg")}>
                <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                  Lorem ipsum dolor sit amet.
                </h5>
                <p className="font-normal text-gray-700 dark:text-gray-400">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam dolor dignissimos molestiae rerum nesciunt suscipit quaerat iusto consequuntur porro repellendus.
                </p>
              </Card>
            </div>
          </div>

          <div className="col-span-1 mx-auto">
            <div className="max-w-sm">
              <Card imgSrc={require("../../images/event-1.jpg")}>
                <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                  Lorem ipsum dolor sit amet.
                </h5>
                <p className="font-normal text-gray-700 dark:text-gray-400">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam dolor dignissimos molestiae rerum nesciunt suscipit quaerat iusto consequuntur porro repellendus.
                </p>
              </Card>
            </div>
          </div>

          <div className="col-span-1 mx-auto">
            <div className="max-w-sm">
              <Card imgSrc={require("../../images/event-2.jpg")}>
                <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                  Lorem ipsum dolor sit amet.
                </h5>
                <p className="font-normal text-gray-700 dark:text-gray-400">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam dolor dignissimos molestiae rerum nesciunt suscipit quaerat iusto consequuntur porro repellendus.
                </p>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
